export function getColor(index: number) {
  const colors = [
    "#0099FF", // Accent Blue
    "#4ECDC4", // Teal
    "#85C1E9", // Soft Blue
    "#1E3A5A", // Dark Electric Blue
    "#3A476B", // Medium Blue
    "#A3AED0", // Muted Grey-Blue
    "#00C2FF", // Bright Cyan
    "#5A67D8", // Purple-Blue
    "#63B3ED", // Indigo
    "#2B6CB0"  // Deep Blue
  ];
  return colors[index % colors.length];
}
